// src/theme.ts
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#012369', // color principal
    },
    secondary: {
      main: '#ff66c4', // color secundario
    },
  },
  typography: {
    fontFamily: 'Open Sans, sans-serif',
  },
});

export default theme;
